import { createSelector } from '@reduxjs/toolkit';
import { computersOffNhn } from './computers-off-nhn';
import { externalConnectionsOffNhn } from './external-connections-off-nhn';

export const externalItemsOffNhn = createSelector(
  computersOffNhn,
  externalConnectionsOffNhn,
  (computers, externalConnections) => computers.length > 0 || externalConnections.length > 0,
);
